import React from "react";

export default function SpreedlyDisplayError({ error, type, classRootName }) {
  if (!error) return null;

  return (
    <div className={classRootName}>
      <span className="text-danger">Not a valid {type}</span>
    </div>
  );
}
